import {
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Select,
  Textarea,
} from '@chakra-ui/react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

export const LaunchForm = ({ onSubmit: onConfirmSubmit, emailSent }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = (data) => {
    setIsLoading(true)
    onConfirmSubmit({ data, setIsLoading })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Heading mb={4} size={'lg'} fontWeight={600} textAlign={'center'}>
        Talk to us!
      </Heading>

      <FormControl isInvalid={errors.email}>
        <FormLabel htmlFor="email">Email Address *</FormLabel>
        <Input
          id="email"
          type="email"
          {...register('email', { required: 'This is required' })}
        />
      </FormControl>

      <FormControl mt={4} isInvalid={errors.website}>
        <FormLabel htmlFor="website">Your Website/Project URL *</FormLabel>
        <Input
          id="website"
          type="url"
          {...register('website', { required: 'This is required' })}
        />
      </FormControl>

      <FormControl mt={4} isInvalid={errors.reason}>
        <FormLabel htmlFor="reason">What brought you to Erinaceus *</FormLabel>
        <Select
          id="reason"
          {...register('reason', { required: 'This is required' })}
        >
          <option value="Ask for a new Price Feed">
            Ask for a new Price Feed
          </option>
          <option value="Become a Node Operator">Become a Node Operator</option>
          <option value="Other / I don’t know">Other / I don’t know</option>
        </Select>
      </FormControl>

      <FormControl mt={4} isInvalid={errors.timeframe}>
        <FormLabel htmlFor="timeframe">Estimated launch time frame *</FormLabel>
        <Select
          id="timeframe"
          {...register('timeframe', { required: 'This is required' })}
        >
          <option value="within 1 month">within 1 month</option>
          <option value="1-3 months">1-3 months</option>
          <option value="3-6 months">3-6 months</option>
          <option value="6+ months">6+ months</option>
          <option value="Already live">Already live</option>
        </Select>
      </FormControl>

      <FormControl mt={4}>
        <FormLabel htmlFor="message">Message</FormLabel>
        <Textarea id={'message'} {...register('message')} />
      </FormControl>

      <Button
        isLoading={isLoading}
        w={'full'}
        mt={4}
        variant={emailSent ? 'outline' : 'solid'}
        isDisabled={!!emailSent}
        colorScheme="teal"
        type="submit"
      >
        {emailSent ? 'Email sent!' : 'Lets Talk!'}
      </Button>
    </form>
  )
}
